var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70401 10.6017C4.654 10.4734 4.654 10.3323 4.70401 10.204C5.191 9.0792 6.01765 8.11751 7.07915 7.4408C8.14065 6.76409 9.38919 6.40283 10.6665 6.40283C11.9438 6.40283 13.1924 6.76409 14.2539 7.4408C15.3154 8.11751 16.142 9.0792 16.629 10.204C16.679 10.3323 16.679 10.4734 16.629 10.6017C16.142 11.7265 15.3154 12.6882 14.2539 13.3649C13.1924 14.0416 11.9438 14.4028 10.6665 14.4028C9.38919 14.4028 8.14065 14.0416 7.07915 13.3649C6.01765 12.6882 5.191 11.7265 4.70401 10.6017Z",
    stroke: "#33363F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 12.1173C11.6606 12.1173 12.4664 11.3498 12.4664 10.4029C12.4664 9.45605 11.6606 8.68847 10.6665 8.68847C9.67243 8.68847 8.86658 9.45605 8.86658 10.4029C8.86658 11.3498 9.67243 12.1173 10.6665 12.1173Z",
    stroke: "#33363F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.26c9be7e05972a608407b19abc4aca7d.svg";
export { ForwardRef as ReactComponent };